import React from 'react';
import ReactDOM from 'react-dom/client';
// import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import reportWebVitals from './metrics/reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/scroll-to-top';
import { SettingsProvider } from './components/settings';
import { AuthProvider } from './auth/OAuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// config
import { RAINBOW_VAR } from './config';
// i18n
import './locales/i18n';
// scroll bar
import 'simplebar/src/simplebar.css';
// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
// Sentry
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import './../src/style.css'

// Sentry Setup
if (RAINBOW_VAR.sentryDsn && RAINBOW_VAR.sentryEnv) {
  Sentry.init({
      dsn: RAINBOW_VAR.sentryDsn,
      environment: RAINBOW_VAR.sentryEnv,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <Provider store={store}>
    <AuthProvider>
      <HelmetProvider>
        
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <BrowserRouter>
                <ScrollToTop />
                <App />
              </BrowserRouter>
            </SettingsProvider>
          </LocalizationProvider>
        
      </HelmetProvider>
    </AuthProvider>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
